import React, { Component } from "react";
import maskText from "../helpers/maskText";
export default class OrderDetailAdress extends Component {
  render() {
    return (
      <table
        className={"table table-bordered table-hover"}
        style={{ marginTop: 20 }}
      >
        <thead>
          <tr>
            <td colspan={2}>Sipariş Teslimat Adresi</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <strong>Adres Adı:</strong>
            </td>
            <td>
              {this.props.customer
                ? this.props.address.address_name
                : maskText(this.props.address.address_name, 2)}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Adı Soyadı:</strong>
            </td>
            <td>
              {this.props.customer
                ? this.props.address.full_name
                : maskText(this.props.address.full_name, 2)}
            </td>
          </tr>
          <tr>
            <td>
              <strong>İl:</strong>
            </td>
            <td>
              {this.props.customer
                ? this.props.address.city
                : maskText(this.props.address.city, 2)}
            </td>
          </tr>
          <tr>
            <td>
              <strong>İlçe:</strong>
            </td>
            <td>
              {this.props.customer
                ? this.props.address.town
                : maskText(this.props.address.town, 2)}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Posta Kodu:</strong>
            </td>
            <td>
              {this.props.customer
                ? this.props.address.postal_code
                : maskText(this.props.address.postal_code, 2)}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Telefon:</strong>
            </td>
            <td>
              {this.props.customer
                ? this.props.address.phone
                : maskText(this.props.address.phone, 2)}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Adres:</strong>
            </td>
            <td>
              {this.props.customer
                ? this.props.address.address
                : maskText(this.props.address.address, 2)}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OrderDetailAdress.js